// Temporary purchase/look-builder adapter; remove after shared adoption covers both.
document.addEventListener('pointerdown', (event) => {
  if (!['touch', 'pen'].includes(event.pointerType) || event.button !== 0 || !event.isPrimary) return;
  if (!(event.target instanceof Element)) return;
  const label = event.target.closest('label');
  const selector = label?.closest('volt-option-selector');
  const panel = label?.closest('dialog');
  if (!selector?.closest('lazy-oaf-purchase, [data-mc-look-builder]') || !panel || panel !== selector.querySelector('dialog') ||
      panel.matches(':modal') || !label.querySelector('input[type="radio"]')) return;
  // Cancel compatibility mouse focus only; native label click/change still owns selection.
  event.preventDefault();
}, { capture: true, passive: false });
